// @flow
export const dataKey: 'menu' = 'menu';
